import React from "react";

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  inputRef: React.RefObject<HTMLInputElement>;
}

export function SearchInput({ value, onChange, inputRef }: SearchInputProps) {
  return (
    <div className="relative">
      <svg
        className="-translate-y-1/2 absolute top-1/2 left-3 h-5 w-5 text-gray-400"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
        />
      </svg>
      <input
        ref={inputRef}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Search resources, people, settings…"
        className="w-full rounded-lg border-0 bg-white py-3 pr-4 pl-10 text-gray-900 placeholder-gray-500 focus:border-blue-500 focus:ring-0 focus:ring-offset-0"
      />
    </div>
  );
}
